import React from "react";
import "./LoadingOverlay.css";

const LoadingOverlay = ({ text }) => {
  return (
    <div className="loading-overlay">
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p className="loading-text">{text || "Ładowanie..."}</p>
      </div>
    </div>
  );
};

export default LoadingOverlay;
